import { TextField, Typography } from '@material-ui/core'
import { SubItemFormFilling } from '../../../Filling/Types'
import { trackEventMatomo } from '../../../../helpers/matomo'
import { useContext, useEffect } from 'react';
import CheckIcon from "../../CheckIcon";
import AdditionalInfo from '../../Structure/AdditionalInfo';
import { NewWebFormContext } from '../../../../context/NewWebFormContext';

type props = {
  subitem: SubItemFormFilling,
  placa: string | null,
  setPlaca: Function,
}

export default function PlacaComp({
  subitem,
  placa,
  setPlaca }:
  props) {
  const { ForceUpdate } = useContext(NewWebFormContext);

  const textFieldTitle: string = (() => {
    let title = ''
    if (CheckIcon(subitem, placa) === 'naoOk') {
      title += '* '
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })()

  useEffect(() => {
    if (subitem.ocorrencia) {
      setPlaca(subitem.ocorrencia)
    }
  }, [])

  useEffect(() => {
    if (subitem.padrao) {
      setPlaca(subitem.padrao)
      subitem.ocorrencia = placa
    } if (CheckIcon(subitem, placa) === 'ok') {
      subitem.checked = true
    }
  }, [])

  useEffect(() => {
    if (placa) {
      subitem.ocorrencia = placa
    } if (CheckIcon(subitem, placa) === 'ok') {
      subitem.checked = true
    } else {
      delete subitem.checked
    }
    ForceUpdate()
  }, [placa])

  const placaCarro = (value: string) => {
    return value
      .toUpperCase()
      .replace(/\W/, '')
      .replace(/(\w)(\W)/, '$1')
      .replace(/^(\d)/, '')
      .replace(/^(\w)(\d)/, '$1')
      .replace(/^(\w)(\w)(\d)/, '$1$2')
      .replace(/^(\w{3})(\D)/, '$1')
      .replace(/^(\w{5})(\D)/, '$1')
      .replace(/^(\w{6})(\D)/, '$1')
      .replace(/^(\D{3})(\w)/, '$1-$2')
      .slice(0, 8)
  };

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>

      <TextField
        style={{
          height: '100%',
          backfaceVisibility: 'hidden',
        }}
        fullWidth
        className={`${subitem.itemid}|${subitem.id}`}
        variant='outlined'
        onClick={() => trackEventMatomo('placa de carro', 'click', 'input', 'editar valor')}
        value={placa}
        onChange={(event) => {
          setPlaca(placaCarro(event.target.value))
          if (!event.target.value?.length) {
            delete subitem.ocorrencia
          }
        }}
      />
      {(subitem.foto || subitem.comentario) && placa?.length === 8
        && <AdditionalInfo subItem={subitem} />}
    </>
  )
}
